<template>
  <div>
    <v-data-iterator
      :items="items"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar dark color="primary" class="mb-1" flat>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
          ></v-text-field>
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-spacer></v-spacer>
            <v-select
              v-model="sortBy"
              flat
              solo-inverted
              hide-details
              :items="keys"
              prepend-inner-icon="mdi-magnify"
              label="Sort by"
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn-toggle v-model="sortDesc" mandatory>
              <v-btn large depressed color="primary" :value="false">
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn large depressed color="primary" :value="true">
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row class="mx-3">
          <v-col v-for="item in props.items" :key="item.name" cols="12" sm="4" md="3" lg="2">
            <v-card class="pb-3" @click="customerUid =  item.uid, getCups()">
              <v-card-title class="subheading font-weight-bold white--text primary">{{ item.name }}</v-card-title>

              <v-divider></v-divider>

              <v-list dense>
                <v-list-item v-for="(key, index) in filteredKeys" :key="index">
                  <v-list-item-content :class="{ 'primary--text': sortBy === key }">{{ key }}:</v-list-item-content>
                  <v-list-item-content
                    class="align-end"
                    :class="{ 'primary--text': sortBy === key }"
                  >{{ item[key.toLowerCase()] }}</v-list-item-content>
                </v-list-item>
              </v-list>

              <v-img
                :src="item.imageUrl"
                aspect-ratio="1"
                class="white lighten-2"
                style="height:100px"
                contain
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <!-- <template v-slot:footer>
        <v-row class="my-2 mx-3" align="center" justify="center">
          <span class="white--text">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark text color="white" class="ml-2" v-bind="attrs" v-on="on">
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span class="mr-4 white--text">Page {{ page }} of {{ numberOfPages }}</span>
          <v-btn fab dark color="primary" class="mr-1" @click="formerPage">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab dark color="primary" class="ml-1" @click="nextPage">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>-->
    </v-data-iterator>
    <v-container fluid>
      <v-row>
        <v-col
          v-for="(cup, index) in cups"
          :key="index+ 'cup'"
          @click="cupUid = cup.uid, getSelfies()"
        >
          <v-row
            align="center"
            justify="center"
            style="cursor:pointer;background-image:url('/img/cup.png'); width:300px;height:300px;background-size:600px;background-position:center"
          >
            <img :src="cup.qrCodeUrl" style="height:100px; width:auto;border-radius:5px" />
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <img
      v-for="(selfie, index) in selfies"
      :key="index+ 'selfie'"
      :src="selfie.imageUrl"
      alt
      style="height:100px; width:auto;"
      @click="deleteSelfie(selfie)"
    />
  </div>
</template>

<script>
const fb = require("../firebase.js");

export default {
  data() {
    return {
      itemsPerPageArray: [4, 8, 12],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 4,
      sortBy: "name",
      keys: ["Name", "Reward"],
      items: [],
      cups: [],
      selfies: [],
      customerUid: null,
      cupUid: null,
      unsubscribeCups: null,
      unsubscribeSelfies: null
    };
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter(key => key !== `Name`);
    }
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    getSelfies() {
      console.log("getSelfies");

      let self = this;
      this.selfies = [];
      // return;
      if (this.unsubscribeSelfies) this.unsubscribeSelfies();

      this.unsubscribeSelfies = fb.firebase
        .firestore()
        .collection(
          "customers/" + this.customerUid + "/cups/" + this.cupUid + "/selfies"
        )
        .orderBy("date", "desc")
        .limit(20)
        .onSnapshot(
          snapshot => {
            snapshot.docChanges().forEach(function(change) {
              if (change.type === "added") {
                if (!change.doc.data().imageUrl) {
                  self.selfies.unshift(
                    Object.assign({ uid: change.doc.id }, change.doc.data())
                  );
                } else {
                  self.selfies.push(
                    Object.assign({ uid: change.doc.id }, change.doc.data())
                  );
                }
              }
              if (change.type === "modified") {
                // console.log("modified");
                self.selfies = self.selfies.map(selfie =>
                  selfie.uid == change.doc.id
                    ? Object.assign({ uid: change.doc.id }, change.doc.data())
                    : selfie
                );
              }
              if (change.type === "removed") {
                // console.log("removed");

                self.selfies = self.selfies.filter(function(selfie) {
                  return selfie.uid != change.doc.id;
                });
              }
            });
          },
          error => {
            console.log(error);
          }
        );

      // Later ...

      // Stop listening to changes
    },
    getCups() {
      console.log("getCups");

      let self = this;
      this.cups = [];
      this.selfies = [];
      // return;
      if (this.unsubscribeCups) this.unsubscribeCups();

      this.unsubscribeCups = fb.firebase
        .firestore()
        .collection("customers/" + this.customerUid + "/cups")
        .onSnapshot(
          snapshot => {
            snapshot.docChanges().forEach(function(change) {
              if (change.type === "added") {
                // if (!change.doc.data().imageUrl) {
                //   self.cups.unshift(
                //     Object.assign({ uid: change.doc.id }, change.doc.data())
                //   );
                // } else {
                self.cups.push(
                  Object.assign({ uid: change.doc.id }, change.doc.data())
                );
                // }
              }
              if (change.type === "modified") {
                // console.log("modified");
                self.cups = self.cups.map(cup =>
                  cup.uid == change.doc.id
                    ? Object.assign({ uid: change.doc.id }, change.doc.data())
                    : cup
                );
              }
              if (change.type === "removed") {
                // console.log("removed");

                self.cups = self.cups.filter(function(cup) {
                  return cup.uid != change.doc.id;
                });
              }
            });
          },
          error => {
            console.log(error);
          }
        );

      // Later ...

      // Stop listening to changes
    },
    deleteSelfie(selfie) {
      let self = this;
      fb.firebase
        .storage()
        .ref("/selfies")
        .child(selfie.imageName)
        .delete()
        .then(function() {})
        .catch(function(error) {
          // Uh-oh, an error occurred!
          self.$store.commit("setSnackbar", {
            color: "error",
            timeout: 3000,
            text: error
          });
        });

      fb.firebase
        .firestore()
        .collection(
          "customers/" + this.customerUid + "/cups/" + this.cupUid + "/selfies"
        )
        .doc(selfie.uid)
        .delete()
        .then(function() {
          self.$store.commit("setSnackbar", {
            color: "primary",
            timeout: 3000,
            text: "Seflie deleted"
          });

          // commit("setLoading", false)
        })
        .catch(function(error) {
          console.log(error);
          // commit("setLoading", false)
        });
    }
  },
  created() {
    console.log("getCustomers");
    let self = this;
    fb.firebase
      .firestore()
      .collection("customers")
      .limit(6)
      .onSnapshot(
        snapshot => {
          snapshot.docChanges().forEach(function(change) {
            if (change.type === "added") {
              // if (!change.doc.data().imageUrl) {
              self.items.unshift(
                Object.assign({ uid: change.doc.id }, change.doc.data())
              );
              // } else {
              //   self.items.push(
              //     Object.assign({ uid: change.doc.id }, change.doc.data())
              //   );
              // }
            }
            if (change.type === "modified") {
              // console.log("modified");
              self.items = self.items.map(item =>
                item.uid == change.doc.id
                  ? Object.assign({ uid: change.doc.id }, change.doc.data())
                  : item
              );
            }
            if (change.type === "removed") {
              // console.log("removed");

              self.items = self.items.filter(function(item) {
                return item.uid != change.doc.id;
              });
            }
          });
        },
        error => {
          console.log(error);
        }
      );
  }
};
</script>
